import { EditIcon } from '@icons'

import './CircleButton.scss'

interface Props {
  onClick: () => void
}

function CircleButton({ onClick }: Props) {
  return (
    <span className='circle-button' onClick={onClick}>
      <EditIcon />
    </span>
  )
}

export default CircleButton
